import React, { useState, useEffect } from "react";
import { Button } from "../Button/Button";
import { SearchModal } from "../SearchModal/SearchModal";
import { SearchIcon } from "../Icons/Miscellaneous/SearchIcon";
import { FilterIcon } from "../Icons/Miscellaneous/FilterIcon";
import { useDispatch, useSelector } from "react-redux";
import { FilterDrawer } from "../FilterDrawer/FilterDrawer";
import {
  setActiveDrawer,
  clearSelectedFilters,
  setSelectedFilters,
} from "../../Slices/uiSlice";
import { useMobile } from "../../Hooks/useMobile";
import { FilterModal } from "../FilterModal/FilterModal";
import { Modal } from "@mui/material";
import { DRAWER_TYPES } from "Constantes/drawers";
import { useFilterData } from "../../Hooks/useFilterData";
import "./SearchAndFilters.scss";

/**
 * Componente para búsqueda y filtrado avanzado
 */
export const SearchAndFilters = () => {
  const { filterData } = useFilterData();
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [tempFilters, setTempFilters] = useState({
    tipos: [],
    temas: [],
    idiomas: [],
    dificultad: [],
  });

  const dispatch = useDispatch();
  const activeDrawer = useSelector((state) => state.ui.activeDrawer);
  const savedFilters = useSelector((state) => state.ui.selectedFilters);
  const isMobile = useMobile();

  const isFiltersOpen = activeDrawer === DRAWER_TYPES.FILTERS;
  const showModal = isSearchOpen || (!isMobile && isFiltersOpen);
  const showFilterModal = !isMobile && isFiltersOpen;
  const showMobileDrawer = isMobile && isFiltersOpen;
  const showBtns = !isMobile && (isFiltersOpen || isSearchOpen);

  useEffect(() => {
    if (isFiltersOpen) {
      setTempFilters(savedFilters);
    }
  }, [isFiltersOpen, savedFilters]);

  const handleSearchToggle = () => {
    setIsSearchOpen(!isSearchOpen);
    if (isFiltersOpen) {
      dispatch(setActiveDrawer(null));
    }
  };

  const handleFiltersToggle = () => {
    setIsSearchOpen(false);
    dispatch(setActiveDrawer(isFiltersOpen ? null : DRAWER_TYPES.FILTERS));
  };

  const handleClose = () => {
    setIsSearchOpen(false);
    dispatch(setActiveDrawer(null));
    setTempFilters(savedFilters);
  };

  const handleTempFilterChange = (
    category,
    optionId,
    checked,
    replace = false
  ) => {
    setTempFilters((prev) => {
      if (replace && checked) {
        return {
          ...prev,
          [category]: [optionId],
        };
      }

      return {
        ...prev,
        [category]: checked
          ? [...prev[category], optionId]
          : prev[category].filter((id) => id !== optionId),
      };
    });
  };

  const handleApplyFilters = () => {
    dispatch(setSelectedFilters(tempFilters));
    dispatch(setActiveDrawer(null));
  };

  const handleClearFilters = () => {
    dispatch(clearSelectedFilters());
    setTempFilters({
      tipos: [1],
      temas: [],
      idiomas: [],
      dificultad: [],
    });
    dispatch(setActiveDrawer(null));
  };

  const filterProps = {
    savedFilters,
    filterData,
    tempFilters,
    onTempFilterChange: handleTempFilterChange,
    onApplyFilters: handleApplyFilters,
    onClearFilters: handleClearFilters,
    onClose: handleClose,
  };

  return (
    <>
      <Modal
        open={showModal}
        onClose={handleClose}
        aria-labelledby="search-filters-modal"
        slotProps={{
          backdrop: {
            sx: {
              background: "rgba(166, 166, 166, 0.5)",
              backdropFilter: "blur(4px)",
            },
          },
        }}
      >
        <div>
          <SearchModal isOpen={isSearchOpen} onClose={handleClose} />
          <FilterModal
            isOpen={showFilterModal}
            onClose={handleClose}
            {...filterProps}
          />

          <div className="search-and-filters search-and-filters__modal">
            <Button variant="icon" onClick={handleSearchToggle}>
              <SearchIcon />
            </Button>

            <Button variant="icon" onClick={handleFiltersToggle}>
              <FilterIcon />
            </Button>
          </div>
        </div>
      </Modal>
      <div
        className={`search-and-filters ${
          showBtns && "search-and-filters__display-none"
        }`}
      >
        <Button variant="icon" onClick={handleSearchToggle}>
          <SearchIcon />
        </Button>

        <Button variant="icon" onClick={handleFiltersToggle}>
          <FilterIcon />
        </Button>
      </div>

      <FilterDrawer open={showMobileDrawer} {...filterProps} />
    </>
  );
};
